/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */

// utils
import { motion, MotionConfig } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { EASE_HORIZONTE, ehModeloHorizonte, useMovimentoReduzido } from '../../../../../../components/pieces/horizonte/horizonte';
import { useAuth } from '../../../../../../components/context/Info';
import { EASE_AURORA, ehModeloAurora } from '../../../../../../components/pieces/aurora/aurora';
import { EASE_PANORAMA, ehModeloPanorama } from '../../../../../../components/pieces/panorama/panorama';
import { EASE_LARISSA, ehModeloLarissa, tituloEmDoisTons } from '../../../../../../components/pieces/larissa/larissa';
import { EASE_INTERNACIONAL, ehModeloInternacional } from '../../../../../../components/pieces/internacional/internacional';
import inInterna from '../../../../../../components/pieces/internacional/InternacionalInterna.module.css';
import { ensureReadableTextColor, isColorLight } from '../../../../../../utils/FunctionsGlobals';
import { textosSecoesDoSite } from '../../../../../../utils/textosSecoesPorSite';
import styles from './RecommendationPiecesProperties.module.css';
const ApartamentCard = dynamic(() => import('../../../../../../components/carousel/apartment/ApartamentCard'), { ssr: false });
// Modelo "Internacional" (topo 16 + card 13): o MESMO card sem caixa da home (export nomeado), em grade 3/2/1 com o
// cabeçalho de seção do modelo (título 800 + pílula contornada "Ver todos"). import() literal: só quem usa baixa o chunk.
const InternacionalCard = dynamic<IInternacionalCard>(() => import('../../../../../../components/carousel/apartment/CardInternacional').then((m) => m.InternacionalCard), { ssr: false });
import type { IInternacionalCard } from '../../../../../../components/carousel/apartment/CardInternacional';
// Modelo "Norte" (topo 17 + card 14): o MESMO card branco raio 8 da home (export nomeado) em grade 3/2/1, com o
// cabeçalho de seção do modelo (h2 sans 32/500 + "Ver todos" sublinhado). import() literal: só quem usa baixa o chunk.
const NorteCard = dynamic<INorteCard>(() => import('../../../../../../components/carousel/apartment/CardNorte').then((m) => m.NorteCard), { ssr: false });
import type { INorteCard } from '../../../../../../components/carousel/apartment/CardNorte';
import ntInterna from '../../../../../../components/pieces/norte/NorteInterna.module.css';
// Modelo "Campo" (topo 18 + card 15): o MESMO card da home (cartão raio 20, export nomeado) em grade 3/2/1, com o
// cabeçalho de seção do modelo (sobretítulo em versalete + h2 32/800 + pílula "Ver todos →"). import() literal.
const CampoCard = dynamic<ICampoCard>(() => import('../../../../../../components/carousel/apartment/CardCampo').then((m) => m.CampoCard), { ssr: false });
import type { ICampoCard } from '../../../../../../components/carousel/apartment/CardCampo';
import cpInterna from '../../../../../../components/pieces/campo/CampoInterna.module.css';
import { FiArrowRight } from 'react-icons/fi';
const ApartamentCard1 = dynamic(() => import('../../../../../../components/carousel/apartment/ApartamentCard1'), { ssr: false });
// CARD "Foto imersiva" (modelo_card = 4): carrossel de cards 100% foto
const ApartamentImersivo = dynamic(() => import('../../../../../../components/carousel/apartment/ApartamentImersivo'), { ssr: false });
// Modelo "Horizonte" (topo 11 + card 8): o MESMO card da home (export nomeado do CardHorizonte), em
// grade. import() literal: só quem usa o modelo baixa o chunk.
const HorizonteCard = dynamic<IHorizonteCard>(() => import('../../../../../../components/carousel/apartment/CardHorizonte').then((m) => m.HorizonteCard), { ssr: false });
import type { IHorizonteCard } from '../../../../../../components/carousel/apartment/CardHorizonte';
// Quantos relacionados a grade do Horizonte mostra (2 linhas de 3 no desktop; trilho no celular).
const MAX_RELACIONADOS_HORIZONTE = 6;
// Modelos "Aurora" (topo 10 + card 7) e "Panorama" (topo 13 + card 10): o MESMO card da home (exports
// nomeados), em grade — mesmo esquema do Horizonte; import() literal: só quem usa o modelo baixa o chunk.
const AuroraCard = dynamic<IAuroraCard>(() => import('../../../../../../components/carousel/apartment/CardAurora').then((m) => m.AuroraCard), { ssr: false });
import type { IAuroraCard } from '../../../../../../components/carousel/apartment/CardAurora';
const PanoramaCard = dynamic<IPanoramaCard>(() => import('../../../../../../components/carousel/apartment/CardPanorama').then((m) => m.PanoramaCard), { ssr: false });
import type { IPanoramaCard } from '../../../../../../components/carousel/apartment/CardPanorama';
// Modelo "Larissa" (topo 14 + card 11): o MESMO card branco de raio 16 da home (export nomeado), em
// grade de 3 (2 até 1279; trilho no celular) com o cabeçalho de seção do modelo (sobretítulo com traço,
// título em Lora de dois tons, "Ver todos ——"). import() literal: só quem usa o modelo baixa o chunk.
const LarissaCard = dynamic<ILarissaCard>(() => import('../../../../../../components/carousel/apartment/CardLarissa').then((m) => m.LarissaCard), { ssr: false });
import type { ILarissaCard } from '../../../../../../components/carousel/apartment/CardLarissa';
// Modelo "Metrópole" (topo 15 + card 12): o MESMO card branco de borda fina da home (export nomeado), em grade de 3
// (2 até 1279; trilho no celular) com o cabeçalho de seção do modelo (título leve, "Ver todos" no acento).
const MetropoleCard = dynamic<IMetropoleCard>(() => import('../../../../../../components/carousel/apartment/CardMetropole').then((m) => m.MetropoleCard), { ssr: false });
import type { IMetropoleCard } from '../../../../../../components/carousel/apartment/CardMetropole';
import { EASE_METROPOLE, ehModeloMetropole } from '../../../../../../components/pieces/metropole/metropole';
// card 9 (Atelier): os relacionados usam o MESMO carrossel editorial da home.
const CardAtelier = dynamic(() => import('../../../../../../components/carousel/apartment/CardAtelier'), { ssr: false });

const RecommendationPiecesProperties: React.FC<{
    propertiesRelatedActual: Array<any>;
    site: any;
    favorito: Array<number>;
    setFavorito: any;
    imoveisEmpreendimento: boolean;
    allViewProperties: any;
}> = ({ propertiesRelatedActual, site, favorito, setFavorito, imoveisEmpreendimento,allViewProperties }) => {
    const router = useRouter();
    const reduzido = useMovimentoReduzido();
    // Horizonte: só com o topo 11 (gate do modelo) E o card 8 — os outros cards seguem o switch de sempre.
    const cardHorizonte = ehModeloHorizonte(site) && Number(site?.modelo_card) === 8;
    // Aurora / Panorama: a mesma regra — gate do modelo (topo 10 / 13) E o card do modelo (7 / 10).
    const cardAurora = ehModeloAurora(site) && Number(site?.modelo_card) === 7;
    const cardPanorama = ehModeloPanorama(site) && Number(site?.modelo_card) === 10;
    // Larissa: gate do modelo (topo 14) E o card do modelo (11).
    const cardLarissa = ehModeloLarissa(site) && Number(site?.modelo_card) === 11;
    // Metrópole: gate do modelo (topo 15) E o card do modelo (12).
    const cardMetropole = ehModeloMetropole(site) && Number(site?.modelo_card) === 12;
    // Internacional: gate do modelo (topo 16) E o card do modelo (13).
    const cardIn = ehModeloInternacional(site) && Number(site?.modelo_card) === 13;
    // Norte: gate do modelo (topo 17, inline — sem importar norte.ts aqui) E o card do modelo (14).
    const cardNt = Number(site?.modelo_topo) === 17 && Number(site?.modelo_card) === 14;
    // Campo: gate do modelo (topo 18, inline — sem importar campo.ts aqui) E o card do modelo (15).
    const cardCp = Number(site?.modelo_topo) === 18 && Number(site?.modelo_card) === 15;
    const { isMobile1 } = useAuth();
    const cor_font = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    // cs2639 (utils/textosSecoesPorSite): títulos em frase; o nome do empreendimento sai como cadastrado.
    const titulosEmFrase = !!textosSecoesDoSite(site?.id).titulosEmFrase;
    const nomeEmpreendimento = String(propertiesRelatedActual?.[0]?.empreendimento?.nome);
    const RenderTitle = () => {
        if(imoveisEmpreendimento){
            const variavel = `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase();
            return <a href={variavel} target="_blank" rel="noopener noreferrer" className={styles.title} style={{color: cor_font}}>{titulosEmFrase ? `Imóveis no empreendimento ${nomeEmpreendimento}` : <>IMÓVEIS NO EMPREENDIMENTO {nomeEmpreendimento.toUpperCase()}</>}</a>;
        } else {
            return <p className={styles.title} style={{color: cor_font}}>{titulosEmFrase ? 'Imóveis relacionados' : 'IMÓVEIS RELACIONADOS'}</p>;
        }
    };

    const RenderSubtitle = () => {
        if(imoveisEmpreendimento){
            return (
                <p className={styles.title_caracters} style={{color: cor_font}}>
                    {titulosEmFrase ? `Selecionamos alguns imóveis no empreendimento ${nomeEmpreendimento}` : <>SELECIONAMOS ALGUNS IMÓVEIS NO EMPREENDIMENTO {nomeEmpreendimento.toUpperCase()}</>}
                </p>
            );
        }
        return (
            <p className={styles.title_caracters} style={{color: cor_font}}>
                {titulosEmFrase ? 'Selecionamos mais alguns' : 'SELECIONAMOS MAIS ALGUNS'}
                <p className={styles.title_bold} style={{color: cor_font}}>
                    {titulosEmFrase ? ' imóveis no perfil para você' : ' IMÓVEIS NO PERFIL PARA VOCÊ'}
                </p>
            </p>
        );
    };

    if (cardHorizonte && propertiesRelatedActual?.length > 0) {
        const hrefEmpreendimento = imoveisEmpreendimento
            ? `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome?.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase()
            : '';
        // linhas cheias de 3 (3 ou 6 cards): nada de card órfão na última linha
        const itens = propertiesRelatedActual.slice(0, propertiesRelatedActual.length >= MAX_RELACIONADOS_HORIZONTE ? MAX_RELACIONADOS_HORIZONTE : 3);
        return (
            <MotionConfig reducedMotion="user">
                <section className={styles.hz_secao} aria-label={imoveisEmpreendimento ? 'Imóveis no empreendimento' : 'Imóveis relacionados'}>
                    <div className={styles.hz_cabecalho}>
                        <div className={styles.hz_cabecalhoTexto}>
                            <span className={styles.hz_sobretitulo}>
                                <span className={styles.hz_sobretituloLinha} aria-hidden="true" />
                                {imoveisEmpreendimento ? 'No mesmo empreendimento' : 'Selecionamos para você'}
                            </span>
                            <h2 className={styles.hz_titulo}>
                                {imoveisEmpreendimento ? `Imóveis no ${nomeEmpreendimento}` : 'Imóveis relacionados'}
                            </h2>
                        </div>
                        {hrefEmpreendimento ? (
                            <a href={hrefEmpreendimento} target="_blank" rel="noopener noreferrer" className={styles.hz_verTodos}>
                                Ver todos
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <path d="M5 12h14M13 6l6 6-6 6" />
                                </svg>
                            </a>
                        ) : null}
                    </div>
                    <div className={styles.hz_grade}>
                        {itens.map((slide: any, i: number) => (
                            <motion.div
                                key={slide?.id ?? i}
                                className={styles.hz_item}
                                initial={reduzido ? false : { opacity: 0, y: 56 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.12 }}
                                transition={{ duration: 0.9, ease: EASE_HORIZONTE, delay: Math.min(i, 5) * 0.09 }}
                            >
                                <HorizonteCard slide={slide} site={site} codsite={router.query?.codsite} favorito={favorito || []} reduzido={reduzido} />
                            </motion.div>
                        ))}
                    </div>
                </section>
            </MotionConfig>
        );
    }

    if ((cardAurora || cardPanorama) && propertiesRelatedActual?.length > 0) {
        const hrefEmpreendimento = imoveisEmpreendimento
            ? `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome?.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase()
            : '';
        // linhas cheias: Aurora 4 por linha (4 ou 8 cards), Panorama 3 (3 ou 6) — nas larguras com menos
        // colunas o CSS esconde a sobra pelo data-qtd (nada de card órfão); no celular vira trilho.
        const porLinha = cardAurora ? 4 : 3;
        const qtd = propertiesRelatedActual.length >= porLinha * 2 ? porLinha * 2 : propertiesRelatedActual.length >= porLinha ? porLinha : propertiesRelatedActual.length;
        const itens = propertiesRelatedActual.slice(0, qtd);
        // pílula de preço do AuroraCard: as MESMAS contas do CardAurora (cor2 sólida, texto calculado)
        const corPreco = site?.cor2 || '#1c2230';
        const corPrecoTexto = ensureReadableTextColor(isColorLight(corPreco) ? site?.cor11 : site?.cor13, corPreco) || '#ffffff';
        const titulo = imoveisEmpreendimento ? `Imóveis no ${nomeEmpreendimento}` : 'Imóveis relacionados';
        return (
            <MotionConfig reducedMotion="user">
                <section className={cardAurora ? styles.au_secao : styles.pn_faixa} aria-label={imoveisEmpreendimento ? 'Imóveis no empreendimento' : 'Imóveis relacionados'}>
                    <div className={cardAurora ? styles.au_conteudo : styles.pn_painel}>
                        <div className={styles.ap_cabecalho}>
                            <h2 className={styles.ap_titulo}>{titulo}</h2>
                            {hrefEmpreendimento ? (
                                <a href={hrefEmpreendimento} target="_blank" rel="noopener noreferrer" className={styles.ap_verTodos}>
                                    Ver todos
                                    {cardAurora ? (
                                        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <line x1="5" y1="12" x2="19" y2="12" />
                                            <polyline points="12 5 19 12 12 19" />
                                        </svg>
                                    ) : null}
                                </a>
                            ) : null}
                        </div>
                        <div className={styles.ap_grade} data-qtd={qtd}>
                            {itens.map((slide: any, i: number) => (
                                <motion.div
                                    key={slide?.id ?? i}
                                    className={styles.ap_item}
                                    initial={reduzido ? false : { opacity: 0, y: 36 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.12 }}
                                    transition={{ duration: 0.8, ease: cardAurora ? EASE_AURORA : EASE_PANORAMA, delay: Math.min(i, 5) * 0.08 }}
                                >
                                    {cardAurora ? (
                                        <AuroraCard slide={slide} site={site} codsite={router.query?.codsite} favorito={favorito || []} corPreco={corPreco} corPrecoTexto={corPrecoTexto} />
                                    ) : (
                                        <PanoramaCard slide={slide} site={site} codsite={router.query?.codsite} favorito={favorito || []} reduzido={reduzido} />
                                    )}
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            </MotionConfig>
        );
    }

    if (cardCp && propertiesRelatedActual?.length > 0) {
        const hrefEmpreendimento = imoveisEmpreendimento
            ? `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome?.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase()
            : '';
        // linhas cheias de 3 (3 ou 6 cards) no desktop; a grade vira 2 e 1 colunas nas larguras menores.
        const qtd = propertiesRelatedActual.length >= 6 ? 6 : propertiesRelatedActual.length >= 3 ? 3 : propertiesRelatedActual.length;
        const itens = propertiesRelatedActual.slice(0, qtd);
        return (
            <MotionConfig reducedMotion="user">
                <section className={`${cpInterna.secao} ${cpInterna.secaoPapel}`} aria-label={imoveisEmpreendimento ? 'Imóveis no empreendimento' : 'Imóveis semelhantes'} data-builder-section="relacionados">
                    <div className={cpInterna.cabecalho}>
                        <div>
                            <p className={cpInterna.sobretitulo}>{`${itens.length} ${itens.length === 1 ? 'imóvel' : 'imóveis'}`}</p>
                            <h2 className={cpInterna.titulo}>{imoveisEmpreendimento ? `Imóveis no ${nomeEmpreendimento}` : 'Imóveis semelhantes'}</h2>
                        </div>
                        {hrefEmpreendimento ? (
                            <a href={hrefEmpreendimento} target="_blank" rel="noopener noreferrer" className={cpInterna.pilulaContorno}>
                                Ver todos <FiArrowRight aria-hidden="true" />
                            </a>
                        ) : null}
                    </div>
                    <div className={cpInterna.grade}>
                        {itens.map((slide: any, i: number) => (
                            <motion.div
                                key={slide?.id ?? i}
                                className={cpInterna.celula}
                                initial={reduzido ? false : { opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.12 }}
                                transition={{ duration: 0.5, ease: EASE_INTERNACIONAL, delay: (i % 3) * 0.06 }}
                            >
                                <CampoCard slide={slide} site={site} codsite={router.query?.codsite} favorito={favorito || []} />
                            </motion.div>
                        ))}
                    </div>
                </section>
            </MotionConfig>
        );
    }
    if (cardNt && propertiesRelatedActual?.length > 0) {
        const hrefEmpreendimento = imoveisEmpreendimento
            ? `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome?.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase()
            : '';
        // linhas cheias de 3 (3 ou 6 cards) no desktop; a grade vira 2 e 1 colunas nas larguras menores.
        const qtd = propertiesRelatedActual.length >= 6 ? 6 : propertiesRelatedActual.length >= 3 ? 3 : propertiesRelatedActual.length;
        const itens = propertiesRelatedActual.slice(0, qtd);
        return (
            <MotionConfig reducedMotion="user">
                <section className={`${ntInterna.secao} ${ntInterna.secaoBranca}`} aria-label={imoveisEmpreendimento ? 'Imóveis no empreendimento' : 'Imóveis semelhantes'} data-builder-section="relacionados">
                    <div className={ntInterna.cabecalho}>
                        <h2 className={ntInterna.titulo}>{imoveisEmpreendimento ? `Imóveis no ${nomeEmpreendimento}` : 'Imóveis semelhantes'}</h2>
                        {hrefEmpreendimento ? (
                            <a href={hrefEmpreendimento} target="_blank" rel="noopener noreferrer" className={ntInterna.link}>
                                Ver todos
                            </a>
                        ) : null}
                    </div>
                    <div className={ntInterna.grade}>
                        {itens.map((slide: any, i: number) => (
                            <motion.div
                                key={slide?.id ?? i}
                                className={ntInterna.celula}
                                initial={reduzido ? false : { opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.12 }}
                                transition={{ duration: 0.5, ease: EASE_INTERNACIONAL, delay: (i % 3) * 0.06 }}
                            >
                                <NorteCard slide={slide} site={site} codsite={router.query?.codsite} favorito={favorito || []} />
                            </motion.div>
                        ))}
                    </div>
                </section>
            </MotionConfig>
        );
    }
    if (cardIn && propertiesRelatedActual?.length > 0) {
        const hrefEmpreendimento = imoveisEmpreendimento
            ? `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome?.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase()
            : '';
        // linhas cheias de 3 (3 ou 6 cards) no desktop; a grade comum vira 2 e 1 colunas nas larguras menores.
        const qtd = propertiesRelatedActual.length >= 6 ? 6 : propertiesRelatedActual.length >= 3 ? 3 : propertiesRelatedActual.length;
        const itens = propertiesRelatedActual.slice(0, qtd);
        return (
            <MotionConfig reducedMotion="user">
                <section className={`${inInterna.secao} ${inInterna.secaoBranca}`} aria-label={imoveisEmpreendimento ? 'Imóveis no empreendimento' : 'Imóveis semelhantes'} data-builder-section="relacionados">
                    <div className={inInterna.cabecalho}>
                        <h2 className={inInterna.titulo}>{imoveisEmpreendimento ? `Imóveis no ${nomeEmpreendimento}` : 'Imóveis semelhantes'}</h2>
                        {hrefEmpreendimento ? (
                            <a href={hrefEmpreendimento} target="_blank" rel="noopener noreferrer" className={inInterna.pilulaContorno}>
                                Ver todos
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="13 6 19 12 13 18" /></svg>
                            </a>
                        ) : null}
                    </div>
                    <div className={inInterna.grade}>
                        {itens.map((slide: any, i: number) => (
                            <motion.div
                                key={slide?.id ?? i}
                                className={inInterna.celula}
                                initial={reduzido ? false : { opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.12 }}
                                transition={{ duration: 0.7, ease: EASE_INTERNACIONAL, delay: Math.min(i, 5) * 0.08 }}
                            >
                                <InternacionalCard slide={slide} site={site} codsite={router.query?.codsite} favorito={favorito || []} />
                            </motion.div>
                        ))}
                    </div>
                </section>
            </MotionConfig>
        );
    }
    if (cardLarissa && propertiesRelatedActual?.length > 0) {
        const hrefEmpreendimento = imoveisEmpreendimento
            ? `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome?.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase()
            : '';
        // linhas cheias de 3 (3 ou 6 cards): até 1279 o CSS esconde a sobra pelo data-qtd (2 por linha,
        // nada de card órfão); no celular vira trilho com todos.
        const qtd = propertiesRelatedActual.length >= 6 ? 6 : propertiesRelatedActual.length >= 3 ? 3 : propertiesRelatedActual.length;
        const itens = propertiesRelatedActual.slice(0, qtd);
        const titulo = tituloEmDoisTons(imoveisEmpreendimento ? `Imóveis no ${nomeEmpreendimento}` : 'Imóveis relacionados, no mesmo perfil');
        return (
            <MotionConfig reducedMotion="user">
                <section className={styles.lr_secao} aria-label={imoveisEmpreendimento ? 'Imóveis no empreendimento' : 'Imóveis relacionados'}>
                    <div className={styles.lr_conteudo}>
                        <div className={styles.lr_cabecalho}>
                            <div className={styles.lr_cabecalhoTexto}>
                                <span className={styles.lr_sobretitulo}>
                                    <span className={styles.lr_traco} aria-hidden="true" />
                                    {imoveisEmpreendimento ? 'No mesmo empreendimento' : 'Selecionamos para você'}
                                </span>
                                <h2 className={styles.lr_titulo}>
                                    {titulo.forte}
                                    {titulo.suave ? <> <span className={styles.lr_tituloSuave}>{titulo.suave}</span></> : null}
                                </h2>
                            </div>
                            {hrefEmpreendimento ? (
                                <a href={hrefEmpreendimento} target="_blank" rel="noopener noreferrer" className={styles.lr_verTodos}>
                                    Ver todos
                                    <span className={styles.lr_verTodosTraco} aria-hidden="true" />
                                </a>
                            ) : null}
                        </div>
                        <div className={styles.lr_grade} data-qtd={qtd}>
                            {itens.map((slide: any, i: number) => (
                                <motion.div
                                    key={slide?.id ?? i}
                                    className={styles.lr_item}
                                    initial={reduzido ? false : { opacity: 0, y: 32 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.12 }}
                                    transition={{ duration: 0.8, ease: EASE_LARISSA, delay: Math.min(i, 5) * 0.08 }}
                                >
                                    <LarissaCard slide={slide} site={site} codsite={router.query?.codsite} favorito={favorito || []} />
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            </MotionConfig>
        );
    }

    if (cardMetropole && propertiesRelatedActual?.length > 0) {
        const hrefEmpreendimento = imoveisEmpreendimento
            ? `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome?.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase()
            : '';
        // linhas cheias de 3 (3 ou 6 cards): até 1279 o CSS esconde a sobra pelo data-qtd; no celular vira trilho com todos.
        const qtd = propertiesRelatedActual.length >= 6 ? 6 : propertiesRelatedActual.length >= 3 ? 3 : propertiesRelatedActual.length;
        const itens = propertiesRelatedActual.slice(0, qtd);
        return (
            <MotionConfig reducedMotion="user">
                <section className={styles.mt_secao} aria-label={imoveisEmpreendimento ? 'Imóveis no empreendimento' : 'Imóveis semelhantes'}>
                    <div className={styles.mt_conteudo}>
                        <div className={styles.mt_cabecalho}>
                            <div className={styles.mt_cabecalhoTexto}>
                                <span className={styles.mt_sobretitulo}>{imoveisEmpreendimento ? 'No mesmo empreendimento' : 'Selecionamos para você'}</span>
                                <h2 className={styles.mt_titulo}>{imoveisEmpreendimento ? `Imóveis no ${nomeEmpreendimento}` : 'Imóveis semelhantes'}</h2>
                            </div>
                            {hrefEmpreendimento ? (
                                <a href={hrefEmpreendimento} target="_blank" rel="noopener noreferrer" className={styles.mt_verTodos}>
                                    Ver todos
                                    <span className={styles.mt_verTodosTraco} aria-hidden="true" />
                                </a>
                            ) : null}
                        </div>
                        <div className={styles.mt_grade} data-qtd={qtd}>
                            {itens.map((slide: any, i: number) => (
                                <motion.div
                                    key={slide?.id ?? i}
                                    className={styles.mt_item}
                                    initial={reduzido ? false : { opacity: 0, y: 24 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.12 }}
                                    transition={{ duration: 0.7, ease: EASE_METROPOLE, delay: Math.min(i, 5) * 0.08 }}
                                >
                                    <MetropoleCard slide={slide} site={site} codsite={router.query?.codsite} favorito={favorito || []} />
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            </MotionConfig>
        );
    }

    if (propertiesRelatedActual?.length > 0) {
        return (
            <div className={styles.container}>
                {site?.modelo_card == 9 ?
                    <CardAtelier
                        slides={propertiesRelatedActual}
                        title={imoveisEmpreendimento ? `Imóveis no empreendimento ${nomeEmpreendimento}` : 'Imóveis relacionados'}
                        site={site}
                        favorito={favorito}
                        setFavorito={setFavorito}
                        allViewProperties={allViewProperties}
                        codsite={router.query?.codsite}
                        url=""
                        is_mobile={isMobile1}
                    />
                    : site?.modelo_card == 4 ?
                    <ApartamentImersivo
                        slides={propertiesRelatedActual}
                        title="Imóveis Relacionados"
                        site={site}
                        favorito={favorito}
                        setFavorito={setFavorito}
                        allViewProperties={allViewProperties}
                    />
                    : site?.modelo_card == 2 || site?.modelo_card == 3 ?
                    <ApartamentCard1
                        slides={propertiesRelatedActual}
                        title="Imóveis Relacionados"
                        site={site}
                        favorito={favorito}
                        RenderTitle={RenderTitle}
                        RenderSubtitle={RenderSubtitle}
                        cores={null}
                        setFavorito={setFavorito}
                        allViewProperties={allViewProperties}
                    />
                    :
                    <ApartamentCard
                        slides={propertiesRelatedActual}
                        title="Imóveis Relacionados"
                        RenderTitle={RenderTitle}
                        RenderSubtitle={RenderSubtitle}
                        site={site}
                        favorito={favorito}
                        setFavorito={setFavorito}
                        allViewProperties={allViewProperties}
                    />}
            </div>
        );
    }
    return null;
};

export default RecommendationPiecesProperties;

export const getServerSideProps = async () => ({ notFound: true });
